import React, {FC} from 'react';

import {PRODUCT_TYPES} from 'constants/product';

import {CartGiftBanner} from '../../features/vistaPlus/cartGiftBanner/cartGiftBanner';
import {CartItemContactsType, CartItemGlassesTypeV2Type, CartItemType} from '../../types';
import {CartItemAccessory} from '../cartItemAccessory/cartItemAccessory';
import {CartItemContactsConnected} from '../cartItemContacts/cartItemContacts';
import {CartItemEyeglasses as CartItemEyeglassesV2} from '../cartItemEyeglassesV2/cartItemEyeglasses';
import {CartItemUpgrade as CartItemUpgradeV2} from '../cartItemUpgradeV2/cartItemUpgrade';

type PropsType = {
    item: CartItemType;
};

/**
 * Cart item component
 * Show item by type
 * @params {PropsType} props - component props
 * @returns {ReactElement} component specific by cart item type
 */
export const CartItem: FC<PropsType> = ({item}) => {
    switch (item.type) {
        case PRODUCT_TYPES.ACCESSORY: {
            return <CartItemAccessory item={item} />;
        }
        case PRODUCT_TYPES.EYEGLASSES:
        case PRODUCT_TYPES.SUNGLASSES: {
            return <CartItemEyeglassesV2 item={item as CartItemGlassesTypeV2Type} />;
        }
        case PRODUCT_TYPES.CONTACT_LENSES: {
            return <CartItemContactsConnected item={item as CartItemContactsType} />;
        }
        case PRODUCT_TYPES.UPGRADE: {
            return <CartItemUpgradeV2 item={item as CartItemGlassesTypeV2Type} />;
        }
        case PRODUCT_TYPES.GIFT:
            return <CartGiftBanner giftType="vistaPlus" />;
        default: {
            return null;
        }
    }
};
